import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import Toggle from 'components/Toggle';

import { TEST_ID, TOGGLE_TEST_ID, VARIANT_SEGMENTED, VARIANT_SWITCH } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LabeledToggle: FunctionComponent<Props> = ({
    activeIndex,
    className = '',
    hint,
    label,
    onClick,
    options,
    testId = TEST_ID,
    variant = VARIANT_SEGMENTED
}) => {
    const variantClass = variant === VARIANT_SWITCH ? styles.switch : styles.segmented;

    return (
        <VerticalContainer
            className={`${className} ${variantClass} ${styles.labeledToggle}`}
            testId={testId}>
            <Wrapper className={styles.label}>{label}</Wrapper>

            {hint && <Wrapper className={styles.hint}>{hint}</Wrapper>}

            <Toggle
                activeIndex={activeIndex}
                className={styles.toggle}
                onClick={onClick}
                options={options}
                testId={TOGGLE_TEST_ID}
            />
        </VerticalContainer>
    );
};

export default LabeledToggle;
